import { render, staticRenderFns } from "./sortableTagInput.vue?vue&type=template&id=e2d1522e&"
import script from "./sortableTagInput.vue?vue&type=script&lang=js&"
export * from "./sortableTagInput.vue?vue&type=script&lang=js&"
import style0 from "./sortableTagInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports